import { createApp} from 'vue'
import App from './App.vue'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

// import Vue from 'vue';


// import {CKEditor} from 'ckeditor5-vue';
// const { CKEditor } = require('@ckeditor/ckeditor5-vue');
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

// import {CKEditor}  from 'ckeditor4-vue';

//import router
import router from './router'

import 'bootstrap/dist/css/bootstrap.css'
import 'jquery/dist/jquery.min'
import 'popper.js/dist/popper.min'
import 'bootstrap/dist/js/bootstrap.min'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { faUser } from '@fortawesome/free-solid-svg-icons'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { faLock } from '@fortawesome/free-solid-svg-icons'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { faCode } from '@fortawesome/free-solid-svg-icons'
import { faArrowRightFromBracket } from '@fortawesome/free-solid-svg-icons'
import { faKey } from '@fortawesome/free-solid-svg-icons'
import { faTable } from '@fortawesome/free-solid-svg-icons'
import { faArrowCircleLeft } from '@fortawesome/free-solid-svg-icons'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { faListOl } from '@fortawesome/free-solid-svg-icons'
import { faSignature } from '@fortawesome/free-solid-svg-icons'
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import { faClipboard } from '@fortawesome/free-solid-svg-icons'
import { faGear } from '@fortawesome/free-solid-svg-icons'
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons'
import { faBan } from '@fortawesome/free-solid-svg-icons';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { faListCheck } from '@fortawesome/free-solid-svg-icons';
import { faBullseye } from '@fortawesome/free-solid-svg-icons';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { faListAlt } from '@fortawesome/free-regular-svg-icons';
import { faCheckToSlot } from '@fortawesome/free-solid-svg-icons'; 
import { faFileInvoice } from '@fortawesome/free-solid-svg-icons';
import { faCreditCard } from '@fortawesome/free-solid-svg-icons';
import { faComputer } from '@fortawesome/free-solid-svg-icons';
import { faUserTie } from '@fortawesome/free-solid-svg-icons';
import { faUserTag } from '@fortawesome/free-solid-svg-icons';
import { faArrowCircleRight } from '@fortawesome/free-solid-svg-icons';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { faFloppyDisk } from '@fortawesome/free-solid-svg-icons';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { faX } from '@fortawesome/free-solid-svg-icons';
import { faShield } from '@fortawesome/free-solid-svg-icons';
import { faArrowAltCircleDown } from '@fortawesome/free-regular-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';


// import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';

//import adminlte scripts
import "../node_modules/admin-lte/dist/js/adminlte.min.js"

import "../node_modules/admin-lte/plugins/select2/js/select2.full.js"
import "../node_modules/admin-lte/plugins/select2/js/select2.js"
import "../node_modules/admin-lte/plugins/select2/js/select2.full.min.js"
import "../node_modules/admin-lte/plugins/select2/js/select2.min.js"

import "../node_modules/admin-lte/plugins/bootstrap/js/bootstrap.bundle.min.js"
import "../node_modules/admin-lte/plugins/overlayScrollbars/js/jquery.overlayScrollbars.min.js"
//import "../node_modules/admin-lte/plugins/summernote/summernote-bs4.min.js"
//import "../node_modules/admin-lte/plugins/tempusdominus-bootstrap-4/js/tempusdominus-bootstrap-4.min.js"
import "../node_modules/admin-lte/plugins/daterangepicker/daterangepicker.js"
//mport "../node_modules/admin-lte/plugins/moment/moment.min.js"
import "../node_modules/admin-lte/plugins/jquery-knob/jquery.knob.min.js"
//import "../node_modules/admin-lte/plugins/jqvmap/maps/jquery.vmap.usa.js"
//import "../node_modules/admin-lte/plugins/jqvmap/jquery.vmap.min.js"
import "../node_modules/admin-lte/plugins/sparklines/sparkline.js"
//import "../node_modules/admin-lte/plugins/chart.js/Chart.min.js"
import "../node_modules/admin-lte/plugins/jquery/jquery.min.js"
import "../node_modules/admin-lte/plugins/jquery-ui/jquery-ui.min.js"
import "../node_modules/admin-lte/plugins/inputmask/jquery.inputmask.min.js"
//import "../node_modules/admin-lte/plugins/tempusdominus-bootstrap-4/js/tempusdominus-bootstrap-4.min.js"
import "../node_modules/admin-lte/plugins/bootstrap-switch/js/bootstrap-switch.min.js"
import "../node_modules/admin-lte/plugins/bs-stepper/js/bs-stepper.min.js"
import "../node_modules/admin-lte/plugins/dropzone/min/dropzone.min.js"

//import adminlte styles
import '../node_modules/admin-lte/dist/css/adminlte.min.css'
import "../node_modules/admin-lte/plugins/overlayScrollbars/css/OverlayScrollbars.min.css"
import "../node_modules/admin-lte/plugins/summernote/summernote-bs4.min.css"
import "../node_modules/admin-lte/plugins/daterangepicker/daterangepicker.css"
import "../node_modules/admin-lte/plugins/jqvmap/jqvmap.min.css"
import "../node_modules/admin-lte/plugins/icheck-bootstrap/icheck-bootstrap.min.css"
import "../node_modules/admin-lte/plugins/tempusdominus-bootstrap-4/css/tempusdominus-bootstrap-4.min.css"
import "../node_modules/admin-lte/plugins/bootstrap4-duallistbox/bootstrap-duallistbox.min.css"
import "../node_modules/admin-lte/plugins/bs-stepper/css/bs-stepper.min.css"
import "../node_modules/admin-lte/plugins/dropzone/min/dropzone.min.css"
import "../node_modules/admin-lte/plugins/select2/css/select2.css"
import "../node_modules/admin-lte/plugins/select2/css/select2.min.css"


// import "../node_modules/admin-lte/plugins/select2-bootstrap4-theme/select2-bootstrap4.min.css"

//import datatabel 
import "../node_modules/admin-lte/plugins/datatables/jquery.dataTables.min.js"
import "../node_modules/admin-lte/plugins/datatables-bs4/js/dataTables.bootstrap4.min.js"
import "../node_modules/admin-lte/plugins/datatables-responsive/js/dataTables.responsive.min.js"
import "../node_modules/admin-lte/plugins/datatables-responsive/js/responsive.bootstrap4.min.js"
import "../node_modules/admin-lte/plugins/datatables-buttons/js/dataTables.buttons.min.js"
import "../node_modules/admin-lte/plugins/datatables-buttons/js/buttons.bootstrap4.min.js"
import "../node_modules/admin-lte/plugins/jszip/jszip.min.js"
import "../node_modules/admin-lte/plugins/pdfmake/pdfmake.min.js"
import "../node_modules/admin-lte/plugins/pdfmake/vfs_fonts.js"
import "../node_modules/admin-lte/plugins/datatables-buttons/js/buttons.html5.min.js"
import "../node_modules/admin-lte/plugins/datatables-buttons/js/buttons.print.min.js"
import "../node_modules/admin-lte/plugins/datatables-buttons/js/buttons.colVis.min.js"
import "../node_modules/admin-lte/plugins/datatables-scroller/css/scroller.bootstrap4.css"
import "../node_modules/admin-lte/plugins/datatables-scroller/css/scroller.bootstrap4.min.css"

// import "../node_modules/admin-lte/plugins/datatables-buttons/js/buttons.colVis.min.js"

import "../node_modules/admin-lte/dist/js/adminlte.min.js?v=3.2.0"

//Import Bootstrap Icon

library.add(fas,fab,far,faUser,faEnvelope,faLock,faArrowRightFromBracket,faSearch,faKey,faTable,faArrowCircleLeft,faPlus,faListOl,faSignature,faAngleLeft,faClipboard,faGear,faPaperPlane,faBan,faPencilAlt,faPenToSquare,faListCheck,faBullseye,faFilePdf,faListAlt,faCheckToSlot,
    faFileInvoice,faCreditCard,faComputer,faUserTie,faUserTag,faInfoCircle,faFloppyDisk,faTrashAlt,faCheckCircle,faShield,faX, faArrowAltCircleDown)

const app = createApp(App)


//use select2
// import { Select2 } from 'vue3-select2-component';
// app.component('Select2', Select2)
//use vue router

import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'


app.use(router)
app.component('font-awesome-icon',FontAwesomeIcon)
app.use(VueSweetalert2)
app.component('QuillEditor', QuillEditor)
// app.use(QuillEditor)
// app.use(CKEditor)
// app.use(ClassicEditor)
// app.component('ckeditor', CKEditor);

app.mount('#app')